import HStack from '@jimmyboys/liita-ui/dist/components/HStack'
import VStack from '@jimmyboys/liita-ui/dist/components/VStack'
import { useGlobal } from '@jimmyboys/liita-ui/dist/components/GlobalContext'
import styles from './MedicalActsList.module.sass'

const MedicalActsList = (props) => {
	const { items, title, subtitle, displayListLength = false } = props
	const { i18n } = useGlobal()

	return (
		<div className={styles['root']}>
			<HStack gap='xsmall'>
				{title && <h4>{i18n`${title}`}</h4>}
				{displayListLength && (
					<h4 className={styles['counter']}>{items?.length || 0}</h4>
				)}
			</HStack>
			<VStack gap='xsmall'>
				{subtitle && (
					<small className={styles['subtitle']}>{subtitle}</small>
				)}
				<VStack className={styles['list']}>
					{(items || []).map((item, index) => (
						<HStack
							className={`${styles['row']} ${
								!item.enabled ? styles['--disabled'] : null
							}`}
							gap='xsmall'
							justify='space-between'
							columns={item.value ? [3, 1] : [1]}
							key={index}
						>
							<VStack>
								<h5>{item?.title}</h5>
								<small>{item?.subTitle}</small>
							</VStack>
							{item.value && (
								<small className={styles['row-value']}>
									{item.value}
								</small>
							)}
						</HStack>
					))}
				</VStack>
			</VStack>
		</div>
	)
}

export default MedicalActsList
